// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Comfortaa/Comfortaa-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* FONTS  */

@font-face {
  font-family: Popins-regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: Popins-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: Popins-SemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: Comforta-Regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}


.textPrimaryLanding {
  margin-top: 2.125rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 2.5rem;

  font-family: Popins-regular;
  color: #123164
}


.textPrimaryLabelInput {

  font-family: Popins-regular;
  color: black;
  font-weight: 400;
  font-size: 0.875rem;

}

.textPrimaryInput {


  font-family: Popins-regular;
  font-weight: 500;
  font-size: 0.975rem;
  padding-left: 0.938rem;
  color: #5c5b5b;
}

.textPrimartyListInventary {

  font-family: Popins-SemiBold;
  font-size: 11px;
  position: relative;
  text-align: center;
}

.textSecondaryListInventary {
  font-family: Popins-regular;
  text-align: center;
  color: #6A6A6A;
  font-size: 12px;

  position: absolute;
  top: 30px;
}

.textFilterCount {
  font-family: Popins-regular;
  color: #000;
  margin-bottom: 0;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.textFilterCountSelect {
  font-family: Popins-regular;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.215px;
  letter-spacing: 0.202px;
  margin-bottom: 0;
}

.textSelectFilter {
  color: #B1B2B2;
  font-family: Popins-regular;
  margin-bottom: 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.textNumberLines {
  color: #000;
  font-family: Popins-regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 0;
}

.textInputPrimaryFilter {
  font-family: Popins-regular;
  font-size: 0, 875rem;
  color: #7D7D7D;
}

.textCardUserTable {
  font-family: Popins-regular;
  font-weight: 600;
  font-size: 14px;
}

.textErrorInput {

  color: red;
  font-family: Popins-regular;
  position: absolute;
  top: 87px;
  font-size: 0.975rem;

}

.textPrimaryButton {

  color: white;
  font-family: Popins-regular;
  font-weight: 500;
  font-size: 1.125rem;
}

.textCheckedSidebar {

  color: white;
  font-family: Popins-Medium;
  font-size: 1rem;
  position: relative;
  top: 8px;
  margin-left: 12px;
  white-space: nowrap;
  margin-bottom: 10px;
}

.textNotCheckedSidebar {

  color: #123164;
  font-family: Popins-Medium;
  font-size: 1rem;
  position: relative;
  top: 8px;
  white-space: nowrap;
  margin-left: 12px;
  margin-bottom: 10px;
}


.textPrimaryHeaderDashboard {
  font-family: Popins-SemiBold;
  font-size: 1.875rem;
  color: #123164;

}

.textPrimaryResumeProgress {

  font-family: Popins-Medium;
  font-size: 0.975rem;
}

.textBtnFilterManager {
  
  font-family: Popins-Medium;
  font-weight: 500;
  font-size: 15px;
}

.textPositionTableListManager {

  color: #000000;
  font-family: Popins-SemiBold;
  position: relative;
  top: 8px;
  margin-left: 10px;
  margin-right: 3px;
  font-size: 12px;
}

.textPrimaryInputFilterManager {
  font-family: Popins-regular;
  font-size: 0.875rem;
  margin-bottom: 0.875rem;
}

.modal-dialog-erros {

  width: 375px;
  margin: 30px auto;
  border-radius: 20px;
}

.textReasonFilterManager {

  color: #123164;
  font-family: Popins-Medium;
  font-size: 1rem;
  cursor: pointer;

}

.textBtnModalFilterManager {
  color: white;
  font-family: Popins-Medium;
  font-weight: 500;
  font-size: 15px;

}

.textCountInputFilterManager {

  color: white;
  font-family: Popins-Medium;
  font-size: 1.313rem;
}

.textModalFilterManager {

  font-size: 18px;
  font-family: Popins-Medium;
  position: relative;
  top: 7px;
  right: 30px;


}

.textNameManageMentPage {

  font-family: Popins-regular;
  color: #000000;
  font-size: 12px;
  position: relative;
  top: 8px;
  margin-left: 11px;
  margin-right: 10px;
}

.textBtnTableListStock {

  color: white;
  font-family: Popins-Medium;
  font-size: 0.93rem;

}

.textNameTableListUserColum2 {

  font-family: Popins-Medium;
  color: #6A6A6A;
  font-size: 0.87rem;
  text-align: center;
  width: 220px;
  position: relative;
  top: -6px;

}

.textNameTableListUser {

  font-family: Popins-Medium;
  color: #6A6A6A;
  font-size: 0.87rem;
  text-align: center;
  width: 220px;
  position: relative;
  top: -6px;
}

.scrolltest {

  position: fixed;
  bottom: 20px;
  transform: translate(-1%, -10%);
}

.errorMessage {

  font-family: Popins-regular;
  color: red;
  font-size: 0.9rem;
  position: absolute;
  top: 84px;
  left: 2px;

}


.textNameTableListManager {

  font-family: Popins-Regular;
  color: #000000;
  font-weight: 600;
  font-size: 12px;
  position: relative;
  top: 8px;
  margin-left: 7px;
  margin-right: 3px;

}

.textNameTableListManager2 {

  font-family: Popins-Regular;
  color: #000000;
  font-weight: 600;
  font-size: 12px;
  position: relative;
  top: 8px;
  margin-right: 3px;

}


.textPrimaryTableListAddStock {

  font-family: Popins-Medium;
  color: #000000;

  font-size: 1.125rem;


}

.textFileCvg {
  font-family: Popins-Medium;
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  margin-top: 5px;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.textLabelInputSelectFilterManager {

  font-family: Popins-Medium;
  color: #000000;
  font-size: 14px;
  margin-bottom: 14px;
  font-weight: 500px;
}

.textSelect {
  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: Popins-Medium;
  font-size: 0.955rem;

}

.textBtnRemove {

  font-family: Popins-Medium;
  color: #EA0000;
  font-size: 0.93rem;
}

.textSelectFilterManager {
  -webkit-appearance: none;
  -moz-appearance: none;
  color: #797979;

  font-family: Popins-Medium;
  font-size: 0.955rem;

}

.textConfirmationRemove {
  font-family: Popins-regular;
  font-size: 1.12rem;
  text-align: center;
  margin-top: 1.37rem;
}

.textClientInfoHeader {
  margin-top: 15px;
  font-size: 0.9rem;
  font-family: Comforta-Regular;
  position: relative;
  right: 12px;
}


.textPrimaryCount {

  font-family: Popins-Medium;
  color: #000000;
  position: relative;
  top: 4px;
  left: 10px;
  font-weight: 500;
  font-size: 0.75rem;
}

.textPercentageCount {

  font-family: Popins-Medium;
  font-size: 0.75rem;
  font-weight: 500;
  position: relative;
  top: -5px;
  color: #545454;
  text-align: center;
}

.textBtnFilterManagerModal {
  font-family: Popins-Medium;
  font-size: 0.938rem;
  color: white;

}

.textCardDivergences {
  font-family: Popins-regular;
  font-size: 0.87rem;
  color: #000000;
  position: relative;
  top: 5px;
}

.textCountNumberCardDivergence {

  font-family: Popins-regular;
  font-size: 0.87rem;
  color: #000000;
  position: absolute;
  top: 34px;
  right: -19px;
}

.textPrimaryModalFilterManager {

  font-family: Popins-Medium;
  font-size: 1.125rem;
  margin-left: 18px;
}

::-webkit-scrollbar {
  width: 9px;
  height: 10px;
  background: #D8D8D8;
  border-radius: 50px;

}

/* Track */
::-webkit-scrollbar-track {
  background: #D8D8D8;
  border-radius: 10px;
  height: 35px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.33);
  border-radius: 10px;
}


.scrollParticipantsv::-webkit-scrollbar {
  width: 9px;
  /* Largura da barra de rolagem vertical */
  height: 5px;
  /* Altura da barra de rolagem horizontal */
}

/* Estilo do preenchimento da barra de rolagem */
.scrollParticipantsv::-webkit-scrollbar-thumb {
  background-color: #888;
  /* Cor do preenchimento da barra de rolagem */
  border-radius: 4px;
  /* Raio de borda do preenchimento */
}

/* Estilo do fundo da barra de rolagem */
.scrollParticipantsv::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Cor do fundo da barra de rolagem */
}


.semi_circular_slider {

  margin-top: -20px;
  position: relative;

}

.textContDashboard {
  position: relative;
  top: 6px;
  left: 9px;
  font-family: Popins-SemiBold;
  font-size: 0.75rem;
}

.textContPercentage {

  position: relative;
  top: 4px;
  left: 15px;
  text-align: left;
  font-size: 0.913rem;
  color: #545454;
}

.modal-filter-table-list-user {

  width: 74.414vw;
  max-width: 46vw;
}

.textModalTableListUserEditPrimary {
  font-family: Popins-Medium;
  color: #030303;
  font-size: 1.12rem;
}

.textModalTableListUserEditSecondary {
  font-family: Popins-Medium;
  color: #EA0000;
  font-weight: 500;
  font-size: 1.12rem;
}

.textContageNewUsers {
  font-family: Popins-Medium;
  font-weight: 500;
  font-size: 0.9375rem;
  margin-bottom: 0;
}

.textTitleInventary{
  color: #000;
font-feature-settings: 'clig' off, 'liga' off;
font-family:  Popins-Medium;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 16px; /* 133.333% */
margin-bottom: 0;
}


.modal-filter-table-list-user-edit {

  width: 24.414vw;
  max-width: 24.414vw;
  border-radius: 20px;
}


.modal-filter-manager {

  width: 26.814vw;
}

.modal-filter-upload {

  width: 24.414vw;


}

.text_semi_circular_slider {
  position: relative;
  top: -140px;
  font-size: 1.3rem;
  text-align: center;
}

.semi_circular_slider path:nth-child(1) {
  fill: none;
  stroke: #cecece;
  stroke-width: 13px;
}

.semi_circular_slider path:nth-child(2) {
  fill: none;
  stroke: #123164;
  stroke-width: 13px;
}

circle {
  fill: #123164;
  stroke: #fff;
  stroke-width: 5px
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;AAEA,WAAW;;AAEX;EACE,2BAA2B;EAC3B,4CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,4CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,4CAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,4CAAmD;AACrD;;;AAGA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;;EAErB,2BAA2B;EAC3B;AACF;;;AAGA;;EAEE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;;;EAGE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,mBAAmB;;AAErB;;AAEA;;EAEE,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;;AAEjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,WAAW;;;AAGb;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;;AAEpB;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,SAAS;;AAEX;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;EAEE,2BAA2B;EAC3B,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;;AAEX;;;AAGA;;EAEE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;;AAEnB;;;AAGA;;EAEE,0BAA0B;EAC1B,cAAc;;EAEd,mBAAmB;;;AAGrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;;EAErB,0BAA0B;EAC1B,mBAAmB;;AAErB;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;;EAEd,0BAA0B;EAC1B,mBAAmB;;AAErB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;AACb;;;AAGA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;;AAEd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;;AAGA;EACE,UAAU;EACV,yCAAyC;EACzC,WAAW;EACX,0CAA0C;AAC5C;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;;AAGA;;EAEE,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb,6CAA6C;AAC7C,2BAA2B;AAC3B,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC,gBAAgB;AAChB;;;AAGA;;EAEE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;;;AAGjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* FONTS  */\n\n@font-face {\n  font-family: Popins-regular;\n  src: url(\"./fonts/Poppins/Poppins-Regular.ttf\");\n}\n\n@font-face {\n  font-family: Popins-Medium;\n  src: url(\"./fonts/Poppins/Poppins-Medium.ttf\");\n}\n\n@font-face {\n  font-family: Popins-SemiBold;\n  src: url(\"./fonts/Poppins/Poppins-SemiBold.ttf\");\n}\n\n@font-face {\n  font-family: Comforta-Regular;\n  src: url(\"./fonts/Comfortaa/Comfortaa-Regular.ttf\");\n}\n\n\n.textPrimaryLanding {\n  margin-top: 2.125rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 2.5rem;\n\n  font-family: Popins-regular;\n  color: #123164\n}\n\n\n.textPrimaryLabelInput {\n\n  font-family: Popins-regular;\n  color: black;\n  font-weight: 400;\n  font-size: 0.875rem;\n\n}\n\n.textPrimaryInput {\n\n\n  font-family: Popins-regular;\n  font-weight: 500;\n  font-size: 0.975rem;\n  padding-left: 0.938rem;\n  color: #5c5b5b;\n}\n\n.textPrimartyListInventary {\n\n  font-family: Popins-SemiBold;\n  font-size: 11px;\n  position: relative;\n  text-align: center;\n}\n\n.textSecondaryListInventary {\n  font-family: Popins-regular;\n  text-align: center;\n  color: #6A6A6A;\n  font-size: 12px;\n\n  position: absolute;\n  top: 30px;\n}\n\n.textFilterCount {\n  font-family: Popins-regular;\n  color: #000;\n  margin-bottom: 0;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.textFilterCountSelect {\n  font-family: Popins-regular;\n  color: #000;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18.215px;\n  letter-spacing: 0.202px;\n  margin-bottom: 0;\n}\n\n.textSelectFilter {\n  color: #B1B2B2;\n  font-family: Popins-regular;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.textNumberLines {\n  color: #000;\n  font-family: Popins-regular;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-bottom: 0;\n}\n\n.textInputPrimaryFilter {\n  font-family: Popins-regular;\n  font-size: 0, 875rem;\n  color: #7D7D7D;\n}\n\n.textCardUserTable {\n  font-family: Popins-regular;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.textErrorInput {\n\n  color: red;\n  font-family: Popins-regular;\n  position: absolute;\n  top: 87px;\n  font-size: 0.975rem;\n\n}\n\n.textPrimaryButton {\n\n  color: white;\n  font-family: Popins-regular;\n  font-weight: 500;\n  font-size: 1.125rem;\n}\n\n.textCheckedSidebar {\n\n  color: white;\n  font-family: Popins-Medium;\n  font-size: 1rem;\n  position: relative;\n  top: 8px;\n  margin-left: 12px;\n  white-space: nowrap;\n  margin-bottom: 10px;\n}\n\n.textNotCheckedSidebar {\n\n  color: #123164;\n  font-family: Popins-Medium;\n  font-size: 1rem;\n  position: relative;\n  top: 8px;\n  white-space: nowrap;\n  margin-left: 12px;\n  margin-bottom: 10px;\n}\n\n\n.textPrimaryHeaderDashboard {\n  font-family: Popins-SemiBold;\n  font-size: 1.875rem;\n  color: #123164;\n\n}\n\n.textPrimaryResumeProgress {\n\n  font-family: Popins-Medium;\n  font-size: 0.975rem;\n}\n\n.textBtnFilterManager {\n  \n  font-family: Popins-Medium;\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.textPositionTableListManager {\n\n  color: #000000;\n  font-family: Popins-SemiBold;\n  position: relative;\n  top: 8px;\n  margin-left: 10px;\n  margin-right: 3px;\n  font-size: 12px;\n}\n\n.textPrimaryInputFilterManager {\n  font-family: Popins-regular;\n  font-size: 0.875rem;\n  margin-bottom: 0.875rem;\n}\n\n.modal-dialog-erros {\n\n  width: 375px;\n  margin: 30px auto;\n  border-radius: 20px;\n}\n\n.textReasonFilterManager {\n\n  color: #123164;\n  font-family: Popins-Medium;\n  font-size: 1rem;\n  cursor: pointer;\n\n}\n\n.textBtnModalFilterManager {\n  color: white;\n  font-family: Popins-Medium;\n  font-weight: 500;\n  font-size: 15px;\n\n}\n\n.textCountInputFilterManager {\n\n  color: white;\n  font-family: Popins-Medium;\n  font-size: 1.313rem;\n}\n\n.textModalFilterManager {\n\n  font-size: 18px;\n  font-family: Popins-Medium;\n  position: relative;\n  top: 7px;\n  right: 30px;\n\n\n}\n\n.textNameManageMentPage {\n\n  font-family: Popins-regular;\n  color: #000000;\n  font-size: 12px;\n  position: relative;\n  top: 8px;\n  margin-left: 11px;\n  margin-right: 10px;\n}\n\n.textBtnTableListStock {\n\n  color: white;\n  font-family: Popins-Medium;\n  font-size: 0.93rem;\n\n}\n\n.textNameTableListUserColum2 {\n\n  font-family: Popins-Medium;\n  color: #6A6A6A;\n  font-size: 0.87rem;\n  text-align: center;\n  width: 220px;\n  position: relative;\n  top: -6px;\n\n}\n\n.textNameTableListUser {\n\n  font-family: Popins-Medium;\n  color: #6A6A6A;\n  font-size: 0.87rem;\n  text-align: center;\n  width: 220px;\n  position: relative;\n  top: -6px;\n}\n\n.scrolltest {\n\n  position: fixed;\n  bottom: 20px;\n  transform: translate(-1%, -10%);\n}\n\n.errorMessage {\n\n  font-family: Popins-regular;\n  color: red;\n  font-size: 0.9rem;\n  position: absolute;\n  top: 84px;\n  left: 2px;\n\n}\n\n\n.textNameTableListManager {\n\n  font-family: Popins-Regular;\n  color: #000000;\n  font-weight: 600;\n  font-size: 12px;\n  position: relative;\n  top: 8px;\n  margin-left: 7px;\n  margin-right: 3px;\n\n}\n\n.textNameTableListManager2 {\n\n  font-family: Popins-Regular;\n  color: #000000;\n  font-weight: 600;\n  font-size: 12px;\n  position: relative;\n  top: 8px;\n  margin-right: 3px;\n\n}\n\n\n.textPrimaryTableListAddStock {\n\n  font-family: Popins-Medium;\n  color: #000000;\n\n  font-size: 1.125rem;\n\n\n}\n\n.textFileCvg {\n  font-family: Popins-Medium;\n  color: #000000;\n  font-weight: 400;\n  font-size: 14px;\n  margin-top: 5px;\n  white-space: nowrap;\n  width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.textLabelInputSelectFilterManager {\n\n  font-family: Popins-Medium;\n  color: #000000;\n  font-size: 14px;\n  margin-bottom: 14px;\n  font-weight: 500px;\n}\n\n.textSelect {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  font-family: Popins-Medium;\n  font-size: 0.955rem;\n\n}\n\n.textBtnRemove {\n\n  font-family: Popins-Medium;\n  color: #EA0000;\n  font-size: 0.93rem;\n}\n\n.textSelectFilterManager {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  color: #797979;\n\n  font-family: Popins-Medium;\n  font-size: 0.955rem;\n\n}\n\n.textConfirmationRemove {\n  font-family: Popins-regular;\n  font-size: 1.12rem;\n  text-align: center;\n  margin-top: 1.37rem;\n}\n\n.textClientInfoHeader {\n  margin-top: 15px;\n  font-size: 0.9rem;\n  font-family: Comforta-Regular;\n  position: relative;\n  right: 12px;\n}\n\n\n.textPrimaryCount {\n\n  font-family: Popins-Medium;\n  color: #000000;\n  position: relative;\n  top: 4px;\n  left: 10px;\n  font-weight: 500;\n  font-size: 0.75rem;\n}\n\n.textPercentageCount {\n\n  font-family: Popins-Medium;\n  font-size: 0.75rem;\n  font-weight: 500;\n  position: relative;\n  top: -5px;\n  color: #545454;\n  text-align: center;\n}\n\n.textBtnFilterManagerModal {\n  font-family: Popins-Medium;\n  font-size: 0.938rem;\n  color: white;\n\n}\n\n.textCardDivergences {\n  font-family: Popins-regular;\n  font-size: 0.87rem;\n  color: #000000;\n  position: relative;\n  top: 5px;\n}\n\n.textCountNumberCardDivergence {\n\n  font-family: Popins-regular;\n  font-size: 0.87rem;\n  color: #000000;\n  position: absolute;\n  top: 34px;\n  right: -19px;\n}\n\n.textPrimaryModalFilterManager {\n\n  font-family: Popins-Medium;\n  font-size: 1.125rem;\n  margin-left: 18px;\n}\n\n::-webkit-scrollbar {\n  width: 9px;\n  height: 10px;\n  background: #D8D8D8;\n  border-radius: 50px;\n\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #D8D8D8;\n  border-radius: 10px;\n  height: 35px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.33);\n  border-radius: 10px;\n}\n\n\n.scrollParticipantsv::-webkit-scrollbar {\n  width: 9px;\n  /* Largura da barra de rolagem vertical */\n  height: 5px;\n  /* Altura da barra de rolagem horizontal */\n}\n\n/* Estilo do preenchimento da barra de rolagem */\n.scrollParticipantsv::-webkit-scrollbar-thumb {\n  background-color: #888;\n  /* Cor do preenchimento da barra de rolagem */\n  border-radius: 4px;\n  /* Raio de borda do preenchimento */\n}\n\n/* Estilo do fundo da barra de rolagem */\n.scrollParticipantsv::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n  /* Cor do fundo da barra de rolagem */\n}\n\n\n.semi_circular_slider {\n\n  margin-top: -20px;\n  position: relative;\n\n}\n\n.textContDashboard {\n  position: relative;\n  top: 6px;\n  left: 9px;\n  font-family: Popins-SemiBold;\n  font-size: 0.75rem;\n}\n\n.textContPercentage {\n\n  position: relative;\n  top: 4px;\n  left: 15px;\n  text-align: left;\n  font-size: 0.913rem;\n  color: #545454;\n}\n\n.modal-filter-table-list-user {\n\n  width: 74.414vw;\n  max-width: 46vw;\n}\n\n.textModalTableListUserEditPrimary {\n  font-family: Popins-Medium;\n  color: #030303;\n  font-size: 1.12rem;\n}\n\n.textModalTableListUserEditSecondary {\n  font-family: Popins-Medium;\n  color: #EA0000;\n  font-weight: 500;\n  font-size: 1.12rem;\n}\n\n.textContageNewUsers {\n  font-family: Popins-Medium;\n  font-weight: 500;\n  font-size: 0.9375rem;\n  margin-bottom: 0;\n}\n\n.textTitleInventary{\n  color: #000;\nfont-feature-settings: 'clig' off, 'liga' off;\nfont-family:  Popins-Medium;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 16px; /* 133.333% */\nmargin-bottom: 0;\n}\n\n\n.modal-filter-table-list-user-edit {\n\n  width: 24.414vw;\n  max-width: 24.414vw;\n  border-radius: 20px;\n}\n\n\n.modal-filter-manager {\n\n  width: 26.814vw;\n}\n\n.modal-filter-upload {\n\n  width: 24.414vw;\n\n\n}\n\n.text_semi_circular_slider {\n  position: relative;\n  top: -140px;\n  font-size: 1.3rem;\n  text-align: center;\n}\n\n.semi_circular_slider path:nth-child(1) {\n  fill: none;\n  stroke: #cecece;\n  stroke-width: 13px;\n}\n\n.semi_circular_slider path:nth-child(2) {\n  fill: none;\n  stroke: #123164;\n  stroke-width: 13px;\n}\n\ncircle {\n  fill: #123164;\n  stroke: #fff;\n  stroke-width: 5px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
